// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table_13b1bcae {
  margin: 0;
  padding: 0;
  border: 0;
}
.table_13b1bcae {
  width: 100%;
  border-radius: 0.333em;
}
.table_fixed_13b1bcae {
  table-layout: fixed;
}
.table_fixed_13b1bcae .table__col_13b1bcae {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.table_fixed_13b1bcae .table__col_13b1bcae:has(a:focus-visible) {
  outline-style: solid;
  outline-offset: 1px;
  outline-width: 2px;
  outline-color: #1d5080;
  box-shadow: 0 0 0 4px #fff;
}
.table_fixed_13b1bcae .table__col_13b1bcae:has(a:focus-visible) a:focus-visible {
  outline: none;
  box-shadow: none;
}
.table_fixed_13b1bcae .table__col_13b1bcae:has(a:focus-visible) {
  outline-offset: -2px;
}
.table_fixed_13b1bcae .table__col_13b1bcae > a,
.table_fixed_13b1bcae .table__col_13b1bcae span,
.table_fixed_13b1bcae .table__col_13b1bcae div {
  outline: none;
  box-shadow: none;
}
.table_fixed_13b1bcae .table__col_13b1bcae > a:hover,
.table_fixed_13b1bcae .table__col_13b1bcae span:hover,
.table_fixed_13b1bcae .table__col_13b1bcae div:hover {
  outline: none;
  box-shadow: none;
}
.table_fixed_13b1bcae .table__col_13b1bcae > ul > li {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.table_fixed_13b1bcae .table__col_13b1bcae > ul > li:has(a:focus-visible) {
  outline-style: solid;
  outline-offset: 1px;
  outline-width: 2px;
  outline-color: #1d5080;
  box-shadow: 0 0 0 4px #fff;
}
.table_fixed_13b1bcae .table__col_13b1bcae > ul > li:has(a:focus-visible) a:focus-visible {
  outline: none;
  box-shadow: none;
}
.table_fixed_13b1bcae .table__col_13b1bcae > ul > li > a,
.table_fixed_13b1bcae .table__col_13b1bcae > ul > li span,
.table_fixed_13b1bcae .table__col_13b1bcae > ul > li div {
  outline: none;
  box-shadow: none;
}
.table_fixed_13b1bcae .table__col_13b1bcae > ul > li > a:hover,
.table_fixed_13b1bcae .table__col_13b1bcae > ul > li span:hover,
.table_fixed_13b1bcae .table__col_13b1bcae > ul > li div:hover {
  outline: none;
  box-shadow: none;
}
.table_fixed_13b1bcae .table__col_white-space-normal_13b1bcae {
  white-space: normal;
}
.table_v-align-middle_13b1bcae .table__col_13b1bcae {
  vertical-align: middle;
}
.table_v-align-baseline_13b1bcae .table__col_13b1bcae {
  vertical-align: baseline;
}
.table_v-align-bottom_13b1bcae .table__col_13b1bcae {
  vertical-align: bottom;
}
.table_v-align-top_13b1bcae .table__col_13b1bcae {
  vertical-align: top;
}
.table_bordered-grid_13b1bcae .table__col_13b1bcae {
  border: 0.084rem solid #dce1e5;
  padding-left: 1.334rem;
  padding-right: 1.334rem;
}
.table_bordered-grid_13b1bcae .table__col_13b1bcae:first-child {
  padding-left: 1.334rem;
}
.table_bordered-grid_13b1bcae .table__col_13b1bcae:last-child {
  padding-right: 1.334rem;
}
.table_bordered-columns_13b1bcae {
  border: 1px solid #dce1e5;
}
.table_bordered-columns_13b1bcae .table__col_13b1bcae {
  border-left: 1px solid #dce1e5;
  border-right: 1px solid #dce1e5;
}
.table_bordered-columns_13b1bcae .table__col_separated_13b1bcae {
  border-right-width: 0.167rem;
}
.table__title_13b1bcae {
  font-weight: 600;
}
.table__row_head_13b1bcae > .table__col_13b1bcae {
  padding-top: 0.834rem;
  padding-bottom: 0.834rem;
  vertical-align: middle;
  white-space: normal;
  font-weight: 600;
}
.table__row_head_13b1bcae > .table__col_v-align-middle_13b1bcae {
  vertical-align: middle;
}
.table__row_head_13b1bcae > .table__col_v-align-baseline_13b1bcae {
  vertical-align: baseline;
}
.table__row_head_13b1bcae > .table__col_v-align-bottom_13b1bcae {
  vertical-align: bottom;
}
.table__row_head_13b1bcae > .table__col_v-align-top_13b1bcae {
  vertical-align: top;
}
.table__row_head_13b1bcae > .table__col_nowrap_13b1bcae {
  white-space: nowrap;
}
.table__row_foot_13b1bcae > .table__col_13b1bcae {
  padding-top: 0.834rem;
  padding-bottom: 0.834rem;
  vertical-align: middle;
  white-space: normal;
  font-weight: 600;
}
.table__row_foot_13b1bcae > .table__col_v-align-middle_13b1bcae {
  vertical-align: middle;
}
.table__row_foot_13b1bcae > .table__col_v-align-baseline_13b1bcae {
  vertical-align: baseline;
}
.table__row_foot_13b1bcae > .table__col_v-align-bottom_13b1bcae {
  vertical-align: bottom;
}
.table__row_foot_13b1bcae > .table__col_v-align-top_13b1bcae {
  vertical-align: top;
}
.table__row_foot_13b1bcae > .table__col_nowrap_13b1bcae {
  white-space: nowrap;
}
.table__row_body_zebra_13b1bcae:not(:only-of-type):nth-child(odd):not(.table__row_hovered_13b1bcae) {
  background-color: #f8f9fa;
}
.table__row_body_custom_zebra_13b1bcae:not(.table__row_hovered_13b1bcae) {
  background-color: #f8f9fa;
}
.table__row_body_13b1bcae > .table__col_13b1bcae {
  min-height: 1.666rem;
  height: 100%;
  box-sizing: content-box;
  line-height: 1.9;
}
.table_13b1bcae thead + tbody .table__row_body_13b1bcae:not(.table__row_border_13b1bcae):first-child .table__col_13b1bcae {
  border-top: 1px solid #dce1e5;
}
.table__row_border_13b1bcae > .table__col_13b1bcae {
  border-color: transparent;
}
.table__row_align-middle_13b1bcae > .table__col_13b1bcae {
  vertical-align: middle;
}
.table__row_highlighted_13b1bcae {
  background-color: rgba(64,194,201,0.2) !important;
}
.table__subtitle_13b1bcae {
  font-family: PitchBookFont, 'Helvetica', 'Arial', sans-serif;
  font-weight: 400;
  font-size: 0.834rem;
  line-height: 1.715;
  letter-spacing: normal;
  font-stretch: normal;
}
.table__col_13b1bcae {
  margin: 0;
  border: 0;
  padding: 0.334rem 0.667rem;
  vertical-align: top;
  white-space: nowrap;
}
.table__col_v-align-middle_13b1bcae {
  vertical-align: middle;
}
.table__col_v-align-baseline_13b1bcae {
  vertical-align: baseline;
}
.table__col_v-align-bottom_13b1bcae {
  vertical-align: bottom;
}
.table__col_v-align-top_13b1bcae {
  vertical-align: top;
}
.table__col_13b1bcae:first-child {
  padding-left: 1.334rem;
}
.table__col_13b1bcae:last-child {
  padding-right: 1.334rem;
}
.table__col_default-padding_13b1bcae:first-child {
  padding-left: 0.667rem;
}
.table__col_default-padding_13b1bcae:last-child {
  padding-right: 0.667rem;
}
.table__col_left_13b1bcae {
  text-align: left;
}
.table__col_center_13b1bcae {
  text-align: center;
}
.table__col_right_13b1bcae {
  text-align: right;
}
.table__col_caption_13b1bcae {
  background-color: #eaedef;
  font-weight: 600;
}
.table__col_block_13b1bcae {
  padding: 0;
  height: 3.334rem;
}
.table__col_number_13b1bcae {
  text-align: center;
  width: 3.917rem;
  line-height: 1.715;
}
.table__col_number_13b1bcae:first-child {
  padding-left: 0.667rem;
}
.table__col_white-space-normal_13b1bcae {
  white-space: normal;
}
.table__col_13b1bcae .svg {
  vertical-align: middle;
  display: block;
}
.table__col_13b1bcae .svg svg {
  display: inline-block !important;
  vertical-align: inherit;
}
.table_data-table-rows_13b1bcae .table__row_body_13b1bcae .table__col_13b1bcae {
  padding: 0 1rem;
  height: 2rem;
}
.table_data-table-rows_13b1bcae .table__row_head_13b1bcae .table__col_13b1bcae,
.table_data-table-rows_13b1bcae .table__row_foot_13b1bcae .table__col_13b1bcae {
  height: 3.333rem;
  padding: 0 0.667rem;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `table_13b1bcae`,
	"table_fixed": `table_fixed_13b1bcae`,
	"table__col": `table__col_13b1bcae`,
	"table__col_white-space-normal": `table__col_white-space-normal_13b1bcae`,
	"table_v-align-middle": `table_v-align-middle_13b1bcae`,
	"table_v-align-baseline": `table_v-align-baseline_13b1bcae`,
	"table_v-align-bottom": `table_v-align-bottom_13b1bcae`,
	"table_v-align-top": `table_v-align-top_13b1bcae`,
	"table_bordered-grid": `table_bordered-grid_13b1bcae`,
	"table_bordered-columns": `table_bordered-columns_13b1bcae`,
	"table__col_separated": `table__col_separated_13b1bcae`,
	"table__title": `table__title_13b1bcae`,
	"table__row_head": `table__row_head_13b1bcae`,
	"table__col_v-align-middle": `table__col_v-align-middle_13b1bcae`,
	"table__col_v-align-baseline": `table__col_v-align-baseline_13b1bcae`,
	"table__col_v-align-bottom": `table__col_v-align-bottom_13b1bcae`,
	"table__col_v-align-top": `table__col_v-align-top_13b1bcae`,
	"table__col_nowrap": `table__col_nowrap_13b1bcae`,
	"table__row_foot": `table__row_foot_13b1bcae`,
	"table__row_body_zebra": `table__row_body_zebra_13b1bcae`,
	"table__row_hovered": `table__row_hovered_13b1bcae`,
	"table__row_body_custom_zebra": `table__row_body_custom_zebra_13b1bcae`,
	"table__row_body": `table__row_body_13b1bcae`,
	"table__row_border": `table__row_border_13b1bcae`,
	"table__row_align-middle": `table__row_align-middle_13b1bcae`,
	"table__row_highlighted": `table__row_highlighted_13b1bcae`,
	"table__subtitle": `table__subtitle_13b1bcae`,
	"table__col_default-padding": `table__col_default-padding_13b1bcae`,
	"table__col_left": `table__col_left_13b1bcae`,
	"table__col_center": `table__col_center_13b1bcae`,
	"table__col_right": `table__col_right_13b1bcae`,
	"table__col_caption": `table__col_caption_13b1bcae`,
	"table__col_block": `table__col_block_13b1bcae`,
	"table__col_number": `table__col_number_13b1bcae`,
	"table_data-table-rows": `table_data-table-rows_13b1bcae`
};
export default ___CSS_LOADER_EXPORT___;
